import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { RootState } from './index'
import { GuidedViewMenuResult } from '../api/generated'

export interface MenuState {
  mainMenuMobileIsOpen: boolean
  currentlyLoadingId: string | null
  menuSaveSharePopUpIsOpen: boolean
  menuResultGv: GuidedViewMenuResult | null
  menuResultAllView: GuidedViewMenuResult | null
  menuIdToOpenAtJumpToAllView: string | null | undefined
}

const initialState: MenuState = {
  mainMenuMobileIsOpen: false,
  currentlyLoadingId: null,
  menuSaveSharePopUpIsOpen: false,
  menuResultGv: null,
  menuResultAllView: null,
  menuIdToOpenAtJumpToAllView: null,
}

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openMainMenuMobile: (state) => {
      state.mainMenuMobileIsOpen = true
    },
    closeMainMenuMobile: (state) => {
      state.mainMenuMobileIsOpen = false
    },
    toggleMainMenuMobile: (state) => {
      state.mainMenuMobileIsOpen = !state.mainMenuMobileIsOpen
    },
    setCurrentlyLoadingId: (state, action: PayloadAction<string | null>) => {
      state.currentlyLoadingId = action.payload
    },
    setMenuTreeGv: (
      state,
      action: PayloadAction<GuidedViewMenuResult | null>,
    ) => {
      state.menuResultGv = action.payload
    },
    setMenuTreeAllView: (
      state,
      action: PayloadAction<GuidedViewMenuResult | null>,
    ) => {
      state.menuResultAllView = action.payload
    },
    openMenuSaveSharePopUp: (state) => {
      state.menuSaveSharePopUpIsOpen = true
    },
    closeMenuSaveSharePopUp: (state) => {
      state.menuSaveSharePopUpIsOpen = false
    },
    setMenuIdToOpenAtJumpToAllView: (
      state,
      action: PayloadAction<string | null | undefined>,
    ) => {
      state.menuIdToOpenAtJumpToAllView = action.payload
    },
  },
})

export const {
  openMainMenuMobile,
  closeMainMenuMobile,
  toggleMainMenuMobile,
  setCurrentlyLoadingId,
  openMenuSaveSharePopUp,
  closeMenuSaveSharePopUp,
  setMenuTreeGv,
  setMenuTreeAllView,
  setMenuIdToOpenAtJumpToAllView,
} = menuSlice.actions

export const getMenuState = (state: RootState) => state.menu

export default menuSlice.reducer
